import React, { useEffect, useState } from "react";
import { ContentContainer, SectionPage, Row, Col, ComponentLoader, Button, Heading } from "@snsw-gel/react";
import { history } from "@starterapp/shared-services/history";
import { getLinkedCard, patchReplace } from "../../../services/api-services";
import { dataLayer } from "../../../services/gtm-dataLayer";
import styles from "./ReplaceCard.module.scss";

const ReplaceCardPage = () => {
    const [showSpinner, setShowSpinner] = useState(true);
    const [cardDetails, setCardDetails] = useState({});

    useEffect(() => {
        const currentUrl = window.location.href;
        const pageName = window.location.href.split("/").pop();
        dataLayer(currentUrl, pageName);

        (async () => {
            getLinkedCard(["name", "address", "type"]).then((response) => {
                setCardDetails(response);
                setShowSpinner(false);
            });
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSubmitReplace = () => async (_) => {
        setShowSpinner(true);

        let response;
        try {
            response = await patchReplace();
        } catch (ex) {}

        setShowSpinner(false);

        if (!response._httpStatus || response._httpStatus === 200) {
            sessionStorage.setItem("ConfirmationResponse", "replace");
            sessionStorage.setItem("CardTypeText", cardDetails.cardType);
            history.push("/changeDetailsConfirmation");
            window.dispatchEvent(new PopStateEvent("popstate"));
        } else {
            history.push("/applicationError");
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    };

    return (
        <>
            <ContentContainer>
                <Row>
                    <Col span={12}>
                        <SectionPage>
                            <Heading className={styles["page-heading"]} level={1}>
                                Replace your {cardDetails.cardType}
                            </Heading>
                            <Heading className={styles["account-heading"]} level={3}>
                                Please confirm your MyServiceNSW Account details
                            </Heading>
                            <div className={styles["account-details"]}>
                                <Heading className={styles["detail-label"]} level={5}>
                                    Full Name
                                </Heading>
                                <p className={styles["detail-value"]}>
                                    {cardDetails.firstName} {cardDetails.lastName}
                                </p>
                                <Heading className={styles["detail-label"]} level={5}>
                                    Mailing Address
                                </Heading>
                                <p className={styles["detail-value"]}>
                                    {cardDetails.addressStreet}, {cardDetails.addressCity} {cardDetails.addressState}{" "}
                                    {cardDetails.addressPostcode}
                                </p>
                                <Heading className={styles["detail-label"]} level={5}>
                                    Card Type
                                </Heading>
                                <p className={styles["detail-value"]}>{cardDetails.cardType}</p>
                            </div>
                            <p className={styles["body-copy"]}>
                                If your mailing address is incorrect, please go back to your dashboard and update your details in{" "}
                                <a target="_self" href="https://account.service.nsw.gov.au/manage">
                                    Manage Account
                                </a>
                                .
                            </p>
                            <p className={styles["body-copy"]}>
                                If you are unable to update your details online, please call{" "}
                                <a aria-label="Call us on 1 3 7 7 8 8" href="tel:137788">
                                    13 77 88
                                </a>{" "}
                                or visit your local{" "}
                                <a target="_self" href="https://www.service.nsw.gov.au/service-centre">
                                    {" "}
                                    service centre
                                </a>
                                .
                            </p>
                        </SectionPage>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <div className={styles["button-panel"]}>
                            <Button
                                className={`${styles["replace-button"]} button-item`}
                                id="applyButton"
                                onClick={onSubmitReplace()}
                            >
                                Replace card
                            </Button>
                            <Button
                                className={`${styles["dashboard-button"]} dashboard-button`}
                                variant="secondary"
                                href={process.env.REACT_APP_SENIORS_DASHBOARD_URL}
                            >
                                Back to dashboard
                            </Button>
                        </div>
                    </Col>
                </Row>
            </ContentContainer>
            {showSpinner && <ComponentLoader fullPage />}
        </>
    );
};

export default ReplaceCardPage;
